import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';

export const Schema = (settings) => Yup.object().shape({
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
            <Form.Group as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>Wie sind Sie auf uns aufmerksam geworden?</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};
